import { Box, Button, CircularProgress } from '@mui/material';

interface AppButtonProps {
  children: React.ReactNode;
  type?: 'button' | 'submit';
  color?: 'primary' | 'secondary' | 'accent' | 'text' | 'error';
  isLoading?: boolean;
  height?: number;
  isDisabled?: boolean;
  isFullWidth?: boolean;
  blockEventPropagation?: boolean;
  onClick?(): void;
  style?: React.CSSProperties;
}

const getButtonColor = (color: string): 'primary' | 'secondary' | 'error' => {
  if (color === 'accent') {
    return 'secondary';
  }
  if (color === 'error') {
    return 'error';
  }
  if (color === 'secondary') {
    return 'secondary';
  }
  return 'primary';
};

const AppButton = ({
  type,
  children,
  color = 'primary',
  isLoading,
  height,
  isFullWidth,
  blockEventPropagation,
  isDisabled,
  onClick,
  style,
}: AppButtonProps) => (
  <Button
    disabled={isDisabled}
    type={type || 'button'}
    variant={
      color === 'primary' || color === 'accent' || color === 'secondary' || color === 'error'
        ? 'contained'
        : 'text'
    }
    color={getButtonColor(color)}
    disableElevation
    onClick={(e) => {
      if (blockEventPropagation) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (onClick) {
        onClick();
      }
    }}
    sx={{
      transition: 'width 100ms ease-in-out',
      minWidth: isLoading ? 0 : 160,
      width: isFullWidth ? '100%' : undefined,
      height: height || undefined,
      borderRadius: isLoading ? 20 : undefined,
      minHeight: 40,
      ...(color === 'accent' || color === 'secondary' || color === 'error'
        ? { color: 'common.white' }
        : {}),
    }}
    style={style}
  >
    <Box display="flex" justifyContent="center" alignItems="center" sx={{ whiteSpace: 'nowrap' }}>
      {isLoading ? (
        <CircularProgress
          thickness={5}
          size={28}
          sx={{
            color:
              color === 'primary' || color === 'accent' || color === 'error'
                ? 'common.white'
                : 'primary.main',
          }}
        />
      ) : (
        <>{children}</>
      )}
    </Box>
  </Button>
);

export default AppButton;
